import React from 'react'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'; 

const Form = () => {
    const navigate = useNavigate();  // Hook for navigation

    const handleButtonClick = () => {
        window.open('/assets/learn-punjabi.pdf', '_blank'); // Open the PDF in a new tab
    };

    const handleJoinClassesClick = () => {
        navigate('/meet')
    };
    return (
        <div className='container mx-auto md:py-12 py-8'>

            {/* Button at the top */}
            <div className="flex md:flex-row flex-col gap-4 items-center  justify-center text-center mb-8">

                <button
                    onClick={handleButtonClick}
                    className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition duration-300"
                >
                    Learn Punjabi in 30 Minutes
                </button>

                {/* Join Punjabi and Sandhya Classes Button */}
                <button
                    onClick={handleJoinClassesClick}
                    className="px-6 py-3 bg-red-500 text-white font-semibold rounded-lg hover:bg-red-600 transition duration-300"
                >
                    Join Punjabi and Santhya Classes
                </button>
            </div>

            <div className="flex justify-center">
                <iframe
                    src="https://docs.google.com/forms/d/e/1FAIpQLSdxlGrJAkPsjTtFYApUrSdXJ27Dzpn_AsyO3Zt3n7WuTq1_GQ/viewform?embedded=true"
                    width="640"
                    height="1067"
                    frameBorder="0"
                    marginHeight="0"
                    marginWidth="0"
                    className="w-full max-w-4xl h-[1067px] md:h-[600px]"
                >
                    Loading Form..!
                </iframe>
            </div>
        </div>
    )
}

export default Form